var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrouselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281",
    transform: "translate(-48 -201.76)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145-2",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 201.76)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(48.02 201.761)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M4.25,6.75a4.733,4.733,0,0,0,4.63,4.74.807.807,0,0,1,.22,0h.07A4.747,4.747,0,1,0,4.25,6.75Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M3.931,14.149a3.947,3.947,0,0,0-1.97,3.23,3.914,3.914,0,0,0,1.96,3.21A9.239,9.239,0,0,0,9,22a9.239,9.239,0,0,0,5.08-1.41,3.945,3.945,0,0,0,1.96-3.23,3.937,3.937,0,0,0-1.96-3.21A9.929,9.929,0,0,0,3.931,14.149Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M16.859,11.208h-.05a.468.468,0,0,0-.17.02,3.588,3.588,0,0,1-2.53-.83,4.576,4.576,0,0,0,1.5-3.8,4.641,4.641,0,0,0-.77-2.18,3.59,3.59,0,1,1,2.02,6.79Z",
    fill: "#15345a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M20.248,18.97a7.058,7.058,0,0,1-3.51.78,3.569,3.569,0,0,0,1.22-2.32,3.94,3.94,0,0,0-1.67-3.38,8.255,8.255,0,0,0-2.3-1.26,7.815,7.815,0,0,1,6.7,1.17,3.038,3.038,0,0,1,1.3,2.63A3.046,3.046,0,0,1,20.248,18.97Z",
    fill: "#15345a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrouselected);
export default __webpack_public_path__ + "static/media/grouselected.0e85c65e52bdbe36be59df3c4ee5978e.svg";
export { ForwardRef as ReactComponent };